<script>
/**
 * Version 1.2
 * Corrige la visualización general, mejora el centrado del paginador 
 * y lo hace dinámico (Requiere 2 o mas páginas)
 * 
 * @author Daniel Lepe
 * @date 25 de Sep, 2023
 */
export default {
    name: 'QuickCardFooter',
    props: {
        value: {
            type: [Number, String],
            default: 0
        },
        itemsFetched: {
            type: [Number, String],
            default: 0
        },
        itemsCount: {
            type: [Number, String],
            default: 0
        },
        perPage: {
            type: [Number, String],
            default: 0
        },
        backLabel: {
            type: String, 
            default: 'Atrás'
        },
        nextLabel: {
            type: String, 
            default: 'Adelante'
        },
        lang: {
            type: String,
            default: 'es'
        }
    },
    data: () => {
        return {
            currentPage: 1
        }
    },
    beforeMount(){
        this.currentPage  = parseInt(this.value)
    },
    watch: {
        currentPage(){
            this.$emit('input', this.currentPage)
        }
    }
}
</script>
<template>
    <b-row align-h="end">
        <b-col md="auto" sm="auto">
            <slot name="sumarios"></slot>
        </b-col>
        <b-col md="auto" sm="8">
            <b-card-text class="text-right m-0">
                <p class="p-0 m-0" v-if="lang=='es'">
                    <strong>Página {{value}} de {{Math.ceil(itemsCount / perPage)}}</strong> <br>
                    <small>(Se muestran <strong>{{itemsFetched}} registros</strong> de un total de {{itemsCount}})</small>
                </p>
                <p class="p-0 m-0" v-else-if="lang=='en'">
                    <strong>Page {{value}} of {{Math.ceil(itemsCount / perPage)}}</strong> <br>
                    <small>(Showing <strong>{{itemsFetched}} records</strong> from {{itemsCount}})</small>
                </p>
            </b-card-text>
        </b-col>
        <b-col md="auto" sm="12" v-if="Math.ceil(itemsCount / perPage)>1">
            <b-pagination class="p-0 m-0 mt-1" v-model="currentPage" :total-rows="itemsCount" :per-page="perPage" align="center" :prev-text="backLabel" :next-text="nextLabel"/>
        </b-col>
        <b-col md="auto" sm="4" class="text-right mt-1">
            <!-- <b-card-text class="text-right mt-1"> -->
                <b-button @click="$emit('refresh')" variant="outline-primary" key="fa-refresh">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </b-button>
            <!-- </b-card-text> -->
        </b-col>
    </b-row>
</template>